/* eslint-disable */
import moment from 'moment';
import isArray from 'lodash/isArray';
import mergeWith from 'lodash/mergeWith';
import { PROVIDERS, PROVIDER_ALL } from '../constants';
import { getOriginalProviderCode } from '../../../PatientHealthboard/utils';

const extendTarget = (target, value) => {
  if (isArray(target)) return target.concat(value);
};

const isSameDay = (firstDate, secondDate) =>
  moment(firstDate).isSame(secondDate, 'day');

const itemWithConvertedProviderCode = el => ({
  ...el,
  providerCode:
    el.providerCode === PROVIDERS.DEVICES
      ? getOriginalProviderCode(el.originalProviderCodes)
      : el.providerCode,
});

export const mapHistoryList = (data = [], options = {}, isModal) => {
  const { unit } = options;
  const convertedData = data.map(itemWithConvertedProviderCode);
  const flat =
    convertedData && convertedData[0] && convertedData[0].measurements
      ? convertedData.reduce(
          (res, { measurements }) => res.concat(measurements),
          [],
        )
      : convertedData;

  const safeMeasurements = isModal
    ? flat.map(itemWithConvertedProviderCode)
    : flat.map(item =>
        flat.some(
          source =>
            isSameDay(item.measuredAt, source.measuredAt) &&
            item.providerCode !== source.providerCode,
        )
          ? { ...item, providerCode: PROVIDER_ALL }
          : item,
      );

  const sources = safeMeasurements.reduce(
    (providers, { measuredAt, value: values, providerCode: code }) => {
      const parsed = moment.parseZone(measuredAt);
      const date = (!unit ? parsed : parsed.startOf(unit)).toISOString();

      const provider = providers.get(code) || new Map();
      const measurements = provider.get(date) || new Object();

      const newMeasurements = Object.entries(values).reduce(
        (res, [name, value]) => {
          const prevValue = res[name] || [];
          return { ...res, [name]: [...prevValue, value] };
        },
        {},
      );

      const merged = mergeWith(measurements, newMeasurements, extendTarget);
      return providers.set(code, provider.set(date, merged));
    },
    new Map(),
  );

  return [...sources]
    .map(([source, values]) =>
      [...values].map(([date, values]) => ({ date, source, values })),
    )
    .reduce((results, source) => results.concat(source), [])
    .sort(({ date: prev }, { date: next }) => moment(next) - moment(prev));
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/helpers/mapHistoryList.js